class PressSlider extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.setupVariables();
        this.setupEvents();
        this.startAutoplayCheck();
    }

    disconnectedCallback() {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
      }
    }

    setupVariables() {
        this.autoplayInterval = parseInt(this.dataset.autoplayInterval);
        this.swiper = this.querySelector('.swiper');
        this.slides = this.querySelectorAll('.press__slide');
        this.activeSlide = this.querySelector('.press__slide--active');
        this.activeIndex = parseInt(this.activeSlide.dataset.index);
        this.quotes = this.querySelectorAll('.press__item-text');
        this.activeQuote = this.querySelector('.press__item-text:not(.hidden)');
    }

    setupEvents() {
        this.slides.forEach(slide => {
            slide.addEventListener('click', this.onSlideClick.bind(this));
        });
    }

    startAutoplayCheck() {
      if (!this.autoplayInterval) return;
      this.autoplayTimer = setInterval(() => {
          this.activeIndex = this.activeIndex + 1;
          if (this.activeIndex > this.slides.length) {
            this.activeIndex = 1;
          }
          const activeSlide = this.querySelector(`.press__slide[data-index="${this.activeIndex}"]`);
          if (activeSlide) {
              this.changeSlideStyle(activeSlide);
              this.selectQuote(activeSlide);
          }
      }, this.autoplayInterval * 1000);
   }

    onSlideClick(slide) {
        this.changeSlideStyle(slide.currentTarget);
        this.selectQuote(slide.currentTarget);
    }

    changeSlideStyle(slide) {
        this.activeSlide.classList.remove('press__slide--active');
        slide.classList.add('press__slide--active');
        this.activeSlide = slide;
    }

    selectQuote(slide) {
        const index = slide.dataset.index;
        const quote = this.querySelector(`.press__item-text[data-index="${index}"]`);

        this.activeQuote.classList.add('hidden');
        quote.classList.remove('hidden');
        this.activeQuote = quote;
    }
}

customElements.define('press-slider', PressSlider);